import { Moment } from "moment";
import WeekField, { getWeekWindow } from "components/form/WeekField";
import MonthField, { getMonthWindow } from "components/form/MonthField";
import { SailingReportRangeType } from "view/sailingreports/utils/SailingReportUtils.tsx";

export type Period = SailingReportRangeType.Week | SailingReportRangeType.Month;
export type PeriodWindow = { from: Moment, to: Moment };

export const getPeriodWindow = (date: Date | number | Moment | null | undefined, period: Period): PeriodWindow =>
	period === SailingReportRangeType.Month ? getMonthWindow(date) : getWeekWindow(date);

const PeriodField = ({
	period,
	...props
}: {
	period: Period;
	onChange: (window: PeriodWindow) => void;
	defaultStart?: Date | number | Moment;
	simple?: boolean;
	disabled?: boolean;
}) => period === SailingReportRangeType.Month ? <MonthField {...props} /> : <WeekField {...props} />;

export default PeriodField;
